<div class="dimensjon">
  @for (rad of antallRader; track $index) {
    <div class="rad">
      @for (kol of antallKolonner; track $index) {
        <div class="celle"
             [class.markert]="erCelleMarkert(rad, kol)"
             (click)="velg()"
             (mouseenter)="oppdaterStoerrelse(rad , kol , $event)"></div>
      }
    </div>
  }
  <div class="beskrivelse">{{ tableSize.cols }}&#215;{{ tableSize.rows }}</div>
</div>

